import {
  HorizontalGraph,
  LabelFormatter,
  Row,
  Tabs,
} from 'pages/Shipments/components/HorizontalGraph';
import * as React from 'react';
import { OutstandingFeesBreakdown } from 'services/clients/insights';
import {
  getParamsForView,
  linkFromParams,
} from 'pages/Shipments/components/HorizontalGraph/formatters';
import { CurrentContainerStatus } from 'types/Watchlist';
import { Legend } from '../Legend';
import { useTrackedHistoricalParams } from '../../params';
import { Errors } from '../Errors';
import { useCurrentDateRangeFilter } from '../hooks';

interface Props {
  data: Row[];
  showHistoric: boolean;
  isLoading: boolean;
  errors: Error[];
}

export const ChargesBreakdown: React.FC<Props> = (props) => {
  const { data, showHistoric, isLoading, errors } = props;
  const { searchParams, setSearchParams } = useTrackedHistoricalParams();
  const { breakdown } = searchParams;

  const dateRange = useCurrentDateRangeFilter();
  const labelFormatter: LabelFormatter = React.useCallback(
    (label, key, view) => {
      const params = {
        ...getParamsForView(label, key, view),
        hasPerDiemFees: true,
        containerStatus: [CurrentContainerStatus.Terminated],
        gatedInAt: dateRange,
      };

      return linkFromParams(label, params);
    },
    [dateRange]
  );

  return (
    <div className="space-y-4 flex-grow min-h-0">
      <Tabs
        value={breakdown}
        onChange={(b) => setSearchParams({ breakdown: b as OutstandingFeesBreakdown })}
        options={[
          OutstandingFeesBreakdown.ShippingLine,
          OutstandingFeesBreakdown.Port,
          OutstandingFeesBreakdown.Container,
          OutstandingFeesBreakdown.OceanBOL,
        ]}
      />
      <Legend showHistoric={showHistoric} />
      <HorizontalGraph
        rows={data}
        view={breakdown}
        showHistoric={showHistoric}
        loading={isLoading}
        className="max-h-[800px] pb-4"
        labelFormatter={labelFormatter}
        scrollable
        showTooltips
      />
      <Errors errors={errors} />
    </div>
  );
};
ChargesBreakdown.displayName = 'Shipments.HistoricalPerDiem.ChargesBreakdown';
